<template>
  <div
    class="w-full max-w-full md:w-168 lg:w-168 xl:w-192 h-full aspect-video flex justify-center items-center bg-cover"
    :class="{ 'absolute -z-10 top-0 left-0': absolute }"
    :style="`background-image: url(${placeholderImage});`"
  >
    <div
      class="border-4 border-blue border-t-transparent rounded-full animate-spin w-20 h-20"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    absolute: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      placeholderImage: this.$img('/assets/img/ucrs-placeholder.png'),
    }
  },

  head() {
    const link = [
      {
        rel: 'preload',
        as: 'image',
        href: this.placeholderImage,
        fetchpriority: 'high',
      },
    ]

    return { link }
  },
}
</script>
